import { render, staticRenderFns } from "./LocationCriteria.vue?vue&type=template&id=bb66f548"
import script from "./LocationCriteria.vue?vue&type=script&lang=js"
export * from "./LocationCriteria.vue?vue&type=script&lang=js"
import style0 from "./LocationCriteria.vue?vue&type=style&index=0&id=bb66f548&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports